import styled from 'styled-components';
import { fullscreenMainHeaderHeight } from './fullscreenMainSettings';

const FullscreenMainHeader = styled.div`
    position: relative;
    height: ${fullscreenMainHeaderHeight}; /* Magic number, header height */
    display: flex;
    align-items: center;
`;
export default FullscreenMainHeader;
